import { request } from '../core';
import { Method } from '../core/util';
import { CommonResponse } from '@/utils/types';

export interface VehicleStatusRequest {
  vehicleName: string;
}

export interface VehicleStatus {
  /** 车号 */
  vehicleName: string | null;
  /** 车辆系统状态 */
  systemState: string | null;
  /** 车辆模式 */
  vehicleState: string | null;
  /** 调度状态 */
  scheduleState: string | null;
  /** 速度 */
  speed: number | null;
  /** 经度（GCJ-02） */
  longitude: number | null;
  /** 纬度（GCJ-02） */
  latitude: number | null;
  /** 接管状态 */
  takeOverStatus: string | null;
  /** 接管人 */
  takeOverUserName: string | null;
  /** 接管来源 */
  takeOverSource: string | null;
  /** 箱门打开状态（false 表示全部关闭） */
  boxOpenStatus: boolean | null;
  /** 车辆所属站点名称 */
  stationName: string | null;
  /** 电量 */
  power: number | null;
  /** 插枪状态 */
  chargerConnect: string | null;
}

class VehicleStatusApi {
  public getVehicleStatus(
    params: VehicleStatusRequest,
  ): Promise<CommonResponse<VehicleStatus>> {
    const requestOptions: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/basic/vehicle/status',
      body: params,
    };

    return request(requestOptions);
  }
}

export const vehicleStatusApi = new VehicleStatusApi();
